import { STORE_ALERT, CLEAR_ALERTS } from '../constants/Constants';

export const alertReducer = (state : any = {alerts : []}, action) => {
    switch (action.type) {
      case STORE_ALERT:
      {
        return {
          alerts : state.alerts.concat({
            title : action.payload.title,
            type : action.payload.type,
            link : action.payload.link !== undefined ? action.payload.link : "",
            linkText : action.payload.linkText !== undefined ? action.payload.linkText : ""
          })
        };
      }        
      case CLEAR_ALERTS:
        return {
          alerts : []
        };
      default:
        return state;
    }
};